import { EditOutlined } from '@ant-design/icons';
import { type ComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/comunicazioneDTO.ts';
import { ButtonDeleteConfirm } from '@framework/ui/components/button/ButtonDeleteConfirm.tsx';
import { ButtonIcon } from '@framework/ui/components/button/ButtonIcon.tsx';
import { Space } from 'antd';
import { t } from 'i18next';
import { SignatureBookDetailModalButton } from '#features/packages/common-web/src/ui/communication/detail/signature/SignatureBookDetailModalButton.tsx';
import { CommunicationLogic } from '../../logic/CommunicationLogic.ts';
import { ForwardCommunicationButton } from './ForwardCommunicationButton.tsx';

interface IProps {
  onDelete?: (id: string) => Promise<void>;
  onEdit?: (record: any) => void;
  procedureId: string | null | undefined;
  parentProcedureId: string | null | undefined;
  isProcedureOpen: boolean | null | undefined;
  isEditable: boolean | null | undefined;
  isBackoffice?: boolean;
}

/**
 * Configurazione della colonna "azioni" per una comunicazione in vista tabellare.
 */
export function getCommunicationActionColumn(props: IProps) {
  const {
    onDelete,
    onEdit,
    procedureId,
    parentProcedureId,
    isProcedureOpen,
    isEditable,
    isBackoffice,
  } = props;

  return {
    title: '',
    key: 'actions',
    render: (_: any, record: ComunicazioneDTO) => {
      const isDraft = CommunicationLogic.isDraft(record);
      const isManual = !!record.flCaricataManualmente;
      const sender = CommunicationLogic.sender(record);

      const canBeEdited = CommunicationLogic.canBeEdited({
        isDraft,
        isEditable,
        isManual,
        isProcedureOpen,
        procedureId,
        parentProcedureId,
      });

      return (
        <Space size={0}>
          {/* INOLTRO COMUNICAZIONE */}
          <ForwardCommunicationButton
            communication={record}
            isDraft={isDraft}
            isBackoffice={isBackoffice}
            onEdit={onEdit}
          />

          {canBeEdited && (
            <ButtonIcon
              icon={<EditOutlined />}
              aria-label={t('communication-item.edit', 'Modifica')}
              tooltip={t('communication-item.edit', 'Modifica')}
              onClick={() => onEdit?.(record)}
            />
          )}
          {canBeEdited && (
            <ButtonDeleteConfirm
              size="large"
              iconOnlyButton
              buttonType="link"
              buttonDanger
              onConfirm={async () => {
                if (!record.id) return;
                await onDelete?.(record.id);
              }}
            />
          )}
          {isBackoffice && (
            <SignatureBookDetailModalButton
              communication={record}
              sender={sender}
              iconOnlyButton
            />
          )}
        </Space>
      );
    },
  };
}
